import { useRef, useState } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { uploading, phase } from "../state/store.js";
import { sendMedia } from "../hooks/useConversation.js";
import { prepareFileForUpload, FileTooBigError, UnsupportedFileError } from "../utils/fileUpload.js";
import { Icon } from "./icons.jsx";

export function AttachmentButton() {
  const inputRef = useRef(null);
  const [error, setError] = useState(null);

  const handleChange = async (e) => {
    const file = e.currentTarget.files?.[0];
    e.currentTarget.value = ""; // permite re-seleccionar el mismo archivo
    if (!file) return;
    setError(null);
    try {
      const prepared = await prepareFileForUpload(file);
      await sendMedia(prepared);
    } catch (err) {
      // Errores locales (tamaño/formato) y los del server, que antes se perdían
      // en la burbuja genérica: MEDIA_TOO_LARGE / UNSUPPORTED_MEDIA_TYPE llegan
      // tipados desde ApiError.code.
      if (err instanceof FileTooBigError || err?.code === "MEDIA_TOO_LARGE") setError(strings.attachTooBig);
      else if (err instanceof UnsupportedFileError || err?.code === "UNSUPPORTED_MEDIA_TYPE") setError(strings.attachUnsupported);
      else if (err?.code === "QUOTA_EXCEEDED") setError(strings.attachQuotaExceeded);
      else setError(strings.errorGeneric);
      setTimeout(() => setError(null), 5000);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,application/pdf"
        class="hidden"
        onChange={handleChange}
      />
      <button
        type="button"
        title={strings.attach}
        aria-label={strings.attach}
        disabled={uploading.value || phase.value !== "ready"}
        class="shrink-0 rounded-full bg-white px-3 py-2.5 text-flux-navy shadow-sm disabled:opacity-40 dark:bg-slate-800 dark:text-slate-100"
        onClick={() => inputRef.current?.click()}
      >
        <Icon name={uploading.value ? "loader-circle" : "paperclip"} size={16} class={uploading.value ? "animate-spin" : ""} />
      </button>
      {error && (
        <span class="absolute bottom-full left-2 mb-1 rounded bg-rose-600 px-2 py-1 text-xs text-white">
          {error}
        </span>
      )}
    </>
  );
}
